import $ from 'jquery';

// Reveal speaker bio
$( '.js-expand-speaker-bio' ).on('click', function(e) {
	e.preventDefault();
	$( this ).parents( '.c-speaker-card' ).toggleClass( 'c-speaker-card--is-open' );
} );
